/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TranscodedFile } from '../models/TranscodedFile';
import { HttpFile } from '../http/http';

export class TranscodedFiles {
    'hd': TranscodedFile;
    'sd': TranscodedFile;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "hd",
            "baseName": "hd",
            "type": "TranscodedFile",
            "format": ""
        },
        {
            "name": "sd",
            "baseName": "sd",
            "type": "TranscodedFile",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return TranscodedFiles.attributeTypeMap;
    }

    public constructor() {
    }
}

